import { render, staticRenderFns } from "./ReserveDetail.vue?vue&type=template&id=ed462294&scoped=true&"
import script from "./ReserveDetail.vue?vue&type=script&lang=js&"
export * from "./ReserveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed462294",
  null
  
)

export default component.exports